import { useAuth } from '@/lib/auth/auth';
import type { VenueOwnerOverview } from '@/lib/api/apiTypes';
import { useQuery } from '@tanstack/react-query';

export const venueOwnerOverviewKeys = {
  all: ['venue-owner-overview'] as const,
  detail: (id: string) => [...venueOwnerOverviewKeys.all, id] as const,
};

export function useVenueOwnerOverview(id?: string | null, enabled = true) {
  const request = useAuth((state) => state.request);

  return useQuery({
    queryKey: id ? venueOwnerOverviewKeys.detail(id) : venueOwnerOverviewKeys.all,
    enabled: Boolean(id) && enabled,
    queryFn: () => {
      if (!id) {
        throw new Error('Missing venue id');
      }
      return request<VenueOwnerOverview>(`/venues/${id}/owner-overview`);
    },
    staleTime: 30_000,
  });
}
